import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CheckRounded from '@mui/icons-material/CheckRounded';
import Close from '@mui/icons-material/Close';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Permission from 'shared/features/auth/authorization/enums/permission';
import usePermissionAuthorization from 'shared/features/auth/authorization/hooks/permission-authorization';

import { useGatewaysContextProvider } from 'features/gateway/context/gateway-provider';
import styles from 'features/gateway/views/gateway-details/gateway-details-popup-header.module.scss';

const GatewayDetailsPopupHeader = () => {
  const { hasPermission } = usePermissionAuthorization();
  const { t } = useTranslation('gateway');

  const { formState } = useFormContext();
  const { gatewayDetailsHook } = useGatewaysContextProvider();
  const { cancelMutation, mutationIsLoading, deleteGateway, currentSelectedGateway, openDetailsInEditingMode, closeDetails } =
    gatewayDetailsHook;

  const isViewing = gatewayDetailsHook.viewingMode === 'viewing';
  const isCreating = gatewayDetailsHook.viewingMode === 'creation';
  const isEditing = gatewayDetailsHook.viewingMode === 'editing';

  return (
    <div className={styles.container}>
      {(isCreating || isEditing) && (
        <>
          <Button
            data-testid="gatewayDetailCancelButton"
            variant="text"
            onClick={isCreating ? () => closeDetails(formState.isDirty) : cancelMutation}
            disabled={mutationIsLoading}
          >
            {t('details.cancelFormButton')}
          </Button>
          <Button
            data-testid="gatewayDetailSubmitButton"
            startIcon={<CheckRounded />}
            variant="contained"
            type="submit"
            loading={mutationIsLoading}
            loadingPosition="start"
          >
            {t('details.saveFormButton')}
          </Button>
        </>
      )}
      {isViewing && (
        <>
          {hasPermission(Permission.DeleteGateways) && (
            <Button
              data-testid="gatewayDetailRemoveButton"
              startIcon={<DeleteForeverOutlinedIcon />}
              variant="text"
              onClick={() => deleteGateway(currentSelectedGateway!)}
              disabled={mutationIsLoading}
            >
              {t('details.removeFormButton')}
            </Button>
          )}
          {hasPermission(Permission.UpdateGateways) && (
            <Button
              data-testid="gatewayDetailEditButton"
              startIcon={<ModeEditOutlineOutlinedIcon />}
              variant="text"
              onClick={() => openDetailsInEditingMode(currentSelectedGateway!)}
              disabled={mutationIsLoading}
            >
              {t('details.editFormButton')}
            </Button>
          )}
        </>
      )}

      <IconButton
        aria-label="close"
        className={styles.closeButton}
        onClick={() => closeDetails(formState.isDirty)}
        data-testid="GatewayDetailsPopupCloseButton"
      >
        <Close />
      </IconButton>
    </div>
  );
};

export default GatewayDetailsPopupHeader;
